import { bluePaletteDark, grayPaletteDark } from '../../themes/dark-colors';

export const infoDarkTheme = {
  color: grayPaletteDark[600],
  textUnderlineColor: bluePaletteDark[700],
};
